<template>
<div
    class="vector-canvas"
    :class="{ 'vector-canvas--fit': fitParent }"
    v-bind:style="vectorStyle"
    >
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        v-bind:viewBox="internalViewBox"
        v-bind:preserveAspectRatio="internalPreserveAspectRatio"
        v-html="svg.data"
        v-bind:style="vectorStyle"
        />
</div>
</template>

<script>
import MaidensTower from '@/assets/maidens-tower.svg';
import Schenley from '@/assets/schenley-visitor-center.svg';

function prepareSvg (svg) {
    let viewbox = { xMin: 0, yMin: 0, xMax: 0, yMax: 0 };
    // /<svg[^>]*(viewBox="(d+) (d+) (d+) (d+)")?[^>]*>/i
    let data = svg.replace(/<svg[^>]*>/i,
        (match) => {
            // viewboxStr, xMin, yMin, xMax, yMax,
            // viewboxStr, xMin, yMin, xMax, yMax
            let m = match.match(/viewbox="(\d+) (\d+) (\d+) (\d+)"/i);
            // console.log('replacing viewbox: ', {match, offset, m})
            // to numbers?
            viewbox = {
                xMin: Number(m[1]),
                yMin: Number(m[2]),
                xMax: Number(m[3]),
                yMax: Number(m[4]),
            };
            return ''; // remove svg tag
        }
    );
    data.replace('</svg>', '');
    return { viewbox, data };
}

const vectors = {
    MaidensTower: prepareSvg(MaidensTower),
    Schenley: prepareSvg(Schenley),
    /*
    MaidensTower: {
        viewbox: { xMin: 0, yMin: 0, xMax: 3000, yMax: 400 },
        data: MaidensTower.replace('<svg[]')
    }, // viewbox: { xMin, yMin, xMax, yMax}, data: '...'
    Schenley: {
        viewbox: { xMin: 0, yMin: 0, xMax: 3000, yMax: 400 },
        data: Schenley
    },
    */
}

function uppercaseFirstletter(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export default {
  name: 'VectorCanvas',
  props: {
      /*
      width: {
          type: Number,
      },
      height: {
          type: Number,
      },
      */
      vector: {
          type: String,
      },
      viewBox: {
          type: String,
          // if undefined, get viewbox from svg
      },
      xMin: {
          type: Number,
      },
      xMax: {
          type: Number,
      },
      yMin: {
          type: Number,
      },
      yMax: {
          type: Number,
      },
      preserveAspectRatio: {
          type: String,
      },
      fitParent: {
          type: Boolean,
      },
      alignX: {
          type: String,
          default: 'mid'
          // accepts min mid max
          // will convert to
          // xMin, xMid, xMax
      },
      alignY: {
          type: String,
          default: 'mid'
          // accepts min mid max
          // will convert to
          // yMin, yMid, yMax
      },
      scale: {
          type: String,
          default: 'fit'
          // 'fit' === 'meet'
          // 'cover' === 'slice'
      },
      color: {
          type: String,
          default: '#000',
      }
  },
  computed: {
      svg () {
          return vectors[this.vector];
      },
      internalPreserveAspectRatio () {
          const up = uppercaseFirstletter;
          const meetOrSlice = this.scale === 'cover' ? 'slice' : 'meet';
          return this.preserveAspectRatio || `x${up(this.alignX)}Y${up(this.alignY)} ${meetOrSlice}`;
      },
      internalViewBox () {
          // TODO: default x, y, w, h from svg
          if (this.viewBox) {
              return this.viewBox;
          }
          const _xMin = this.xMin !== undefined ? this.xMin : this.svg.viewbox.xMin;
          const _yMin = this.yMin !== undefined ? this.yMin : this.svg.viewbox.yMin;
          const _xMax = this.xMax !== undefined ? this.xMax : this.svg.viewbox.xMax;
          const _yMax = this.yMax !== undefined ? this.yMax : this.svg.viewbox.yMax;
          return `${_xMin} ${_yMin} ${_xMax} ${_yMax}`;

      },
      vectorStyle () {
          return {
              // viewBox: this.internalViewBox,
              // preserveAspectRatio: this.internalPreserveAspectRatio,
              color: this.color,
              // if () {  }
          };
      },
  },
}
</script>

<style lang="scss">
.vector-canvas > svg {
    width: 100%;
    height: 100%;
}
.vector-canvas--fit {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.nothing {
    color: #866c5a;
}
</style>
